// extracted by mini-css-extract-plugin
export default {"TwoDimsFeature":"wh_a bhs_b bhs_we"};